<template>
  <!-- 效果评估策略制定审核 -->
  <div>
    <el-form ref="applyForm2" :model="addFrom" class="xgpg_audit_form">
      <div class="xgpg_audit_wrap">
        <el-row>
          <transition name="fade">
            <el-table
              v-show="fileListShow"
              :data="xgpg.auditData.files"
              fit
              size="mini"
              border
              stripe
              :header-cell-style="tableHeaderColor"
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
            >
              <el-table-column
                label="操作"
                prop="xmmc"
                min-width="100px"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    @click="handleDownloadFile(scope.row)"
                    style="color: #036eb8; cursor: pointer"
                    >下载</span
                  >
                  <span
                    @click="handleViewFile(scope.row)"
                    style="color: #036eb8; margin: 0 15px; cursor: pointer"
                    >预览</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="文件名字"
                prop="fileName"
                min-width="200px"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <el-table-column
                label="文件类型"
                prop="fileType"
                min-width="80px"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <el-table-column
                label="文件大小"
                prop="fileSize"
                min-width="80px"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <div>
                    {{ (scope.row.fileSize / 1024 / 1024).toFixed(2) }}M
                  </div>
                </template></el-table-column
              >
              <el-table-column
                label="上传人"
                prop="uploader"
                min-width="80px"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <el-table-column
                label="上传时间"
                prop="uploadTime"
                min-width="80px"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
          </transition>
        </el-row>
        <el-row class="scroll_row">
          <div>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>1.结构内容</div>
              </div>
              <el-form-item :label="`咨询师(${xgpg.auditData.xm})`">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="列明每部分内容页数:（1）规划咨询汇报：工作回顾、诊断分析、绩效规划、后续计划等"
                  v-model="xgpg.auditData.v1"
                  disabled
                />
              </el-form-item>
              <el-form-item
                :label="
                  xgpg.auditData.fgsReview.xm
                    ? `分公司(${xgpg.auditData.fgsReview.xm})`
                    : '分公司'
                "
              >
                <el-input
                  type="textarea"
                  :disabled="
                    xgpg.auditData.isReview == 2 || xgpg.auditData.isReview == 3
                  "
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="列明每部分内容页数:（1）规划咨询汇报：工作回顾、诊断分析、绩效规划、后续计划等"
                  v-model="xgpg.auditData.fgsReview.v1"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>2.列明亮点</div>
                <div @click="handleShowHistory">过往评估报告亮点</div>
              </div>
              <el-form-item :label="`咨询师(${xgpg.auditData.xm})`">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="规划咨询报告：规划内容是否有诊断出痛点，是否针对性提出解决建议，是否满足行方绩效改革需求"
                  v-model="xgpg.auditData.v2"
                  disabled
                />
              </el-form-item>
              <el-form-item
                :label="
                  xgpg.auditData.fgsReview.xm
                    ? `分公司(${xgpg.auditData.fgsReview.xm})`
                    : '分公司'
                "
              >
                <el-input
                  type="textarea"
                  :disabled="
                    xgpg.auditData.isReview == 2 || xgpg.auditData.isReview == 3
                  "
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="规划咨询报告：规划内容是否有诊断出痛点，是否针对性提出解决建议，是否满足行方绩效改革需求"
                  v-model="xgpg.auditData.fgsReview.v2"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>3.报告主要逻辑</div>
              </div>
              <el-form-item :label="`咨询师(${xgpg.auditData.xm})`">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  disabled
                  show-word-limit
                  placeholder="评审标准:一句话说明报告主要逻辑，或主要设计思路"
                  v-model="xgpg.auditData.v3"
                />
              </el-form-item>
              <el-form-item
                :label="
                  xgpg.auditData.fgsReview.xm
                    ? `分公司(${xgpg.auditData.fgsReview.xm})`
                    : '分公司'
                "
              >
                <el-input
                  :disabled="
                    xgpg.auditData.isReview == 2 || xgpg.auditData.isReview == 3
                  "
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评审标准:一句话说明报告主要逻辑，或主要设计思路"
                  v-model="xgpg.auditData.fgsReview.v3"
                />
              </el-form-item>
            </el-col>
          </div>
        </el-row>
      </div>
    </el-form>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="this.title"
      :visible.sync="historyDialog"
      width="80%"
      v-if="historyDialog"
      append-to-body
      id="history-dialog"
    >
      <div v-if="historyList && historyList.length > 0">
        <div v-for="(item, index) in historyList" :key="index">
          <div class="history_row">
            <div>申请日期： {{ item.createtime }}</div>
            <div>申请人： {{ item.xm }}</div>
          </div>
          <div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 6, maxRows: 6 }"
              placeholder="请输入备注"
              disabled
              v-model="item.nr"
            />
          </div>
        </div>
      </div>
      <div
        v-else
        style="
          text-align: center;
          font-size: 16px;
          font-weight: 700;
          color: #999;
        "
      >
        <img src="@/img/nodata.png" alt="" width="240" />
        <div>暂无数据</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="historyDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="评审结果确认"
      :visible.sync="adviceDialog"
      width="80%"
      v-if="adviceDialog"
      append-to-body
    >
      <div>
        <div class="advice_row">
          <div>整体意见</div>
          <div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 6, maxRows: 20 }"
              placeholder="请输入整体意见"
              disabled
              v-model="addFrom.advice"
            />
          </div>
        </div>
      </div>
      <div
        class="advice_row"
        v-if="xgpg.auditData.isReview == 1 && status != 2"
      >
        <div><span style="color: #f56c6c">*</span>质量评价</div>
        <div>
          <el-radio-group v-model="evaluation" size="small">
            <el-radio label="3">优秀</el-radio>
            <el-radio label="2">良好</el-radio>
            <el-radio label="1">一般</el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave">确 认</el-button>
        <el-button @click="adviceDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getDict } from "@/api/common.js";
import { getLinkTask, getZxpsGw, saveAuditData } from "@/api/xgpg.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
export default {
  name: "audit",
  computed: {
    ...mapGetters(["deptUser", "xgpg"]),
  },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      historyDialog: false,
      historyList: [],
      adviceDialog: false,
      addFrom: {
        advice: null,
      },
      rules: {},
      pglxList: [],
      status: null,
      parentDialog: false,
      fileListShow: true,
      linkList: [],
      evaluation: null,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.$store.dispatch("xgpg/fetchAuditDataAction", {
      applyId: this.mxParams.applyId,
    });

    Promise.all([
      this.getLinkTaskData(),
      this.getAssessTypeData(),
      this.getData(),
    ]).then(() => {
      this.handleChangeTask(this.xgpg.applyData2.v7);
    });
  },
  methods: {
    getData() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("xgpg/fetchAuditDataAction", {
            applyId: this.mxParams.applyId,
          })
          .then((res) => {
            if (res.code == 0) {
              console.log(this.xgpg.auditData);
              this.fileNum = res.data.files ? 3 - res.data.files.length : 3;
              this.mxParams.status = res.data.status;
              this.mxParams.isExecutor = res.data.isExecutor;
              this.setValue(this.mxParams);
            }
            resolve();
          });
      });
    },
    getLinkTaskData() {
      return new Promise((resolve, reject) => {
        getLinkTask({ taskId: this.mxParams.taskId, type: 1 }).then((res) => {
          if (res.code == 0) {
            this.linkList = res.data;
            resolve();
          }
        });
      });
    },

    getAssessTypeData() {
      return new Promise((resolve, reject) => {
        getDict("assess_type", 1).then((res) => {
          if (res.code == 0) {
            this.pglxList = res.data;
            resolve();
          }
        });
      });
    },
    handleChangeTask(e) {
      for (let i of this.linkList) {
        if (i.task_id == e) {
          this.xgpg.applyData2.type = i.type;
          break;
        }
      }
      this.$forceUpdate();
    },
    handleShowAdvice(e) {
      this.status = e;

      this.addFrom.advice = `结构内容：${
        this.xgpg.auditData.fgsReview.v1
          ? this.xgpg.auditData.fgsReview.v1
          : "暂无"
      }\n
列明亮点：${
        this.xgpg.auditData.fgsReview.v2
          ? this.xgpg.auditData.fgsReview.v2
          : "暂无"
      }\n
报告主要逻辑：${
        this.xgpg.auditData.fgsReview.v3
          ? this.xgpg.auditData.fgsReview.v3
          : "暂无"
      }\n`;
      this.adviceDialog = true;
      this.evaluation = null;
    },
    handleSave() {
      const { isReview, fgsReview, zxbReview, id, jdName, taskId } =
        this.xgpg.auditData;
      if (
        !this.evaluation &&
        this.xgpg.auditData.isReview == 1 &&
        this.status == 1
      ) {
        this.$message.error("请选择质量评价！");
        return;
      }
      let data = {
        applyId: this.mxParams.applyId,
        status: this.status,
        process: isReview,
        id,
        jdName,
        taskId,
        v1: isReview == 1 ? fgsReview.v1 : zxbReview.v1,
        v2: isReview == 1 ? fgsReview.v2 : zxbReview.v2,
        v3: isReview == 1 ? fgsReview.v3 : zxbReview.v3,
        v4: isReview == 1 ? fgsReview.v4 : zxbReview.v4,
        v5: isReview == 1 ? fgsReview.v5 : zxbReview.v5,
        evaluation: this.evaluation,
      };
      if (isReview == 2) {
        data.reviewCount = this.xgpg.auditData.reviewCount;
      }
      saveAuditData(data).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.adviceDialog = false;
          this.$emit("giveFather", false);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleShowHistory() {
      this.historyDialog = true;
      const data = {
        taskId: this.mxParams.taskId,
        linkPoint: this.mxParams.linkPoint,
        page: 1,
        pageSize: 100,
      };
      getZxpsGw(data).then((res) => {
        if (res.code == 0) {
          this.historyList = res.data.zxpsGw;
          this.title = res.data.title;
        }
      });
    },

    setValue() {
      this.$emit("getValue", this.mxParams); //触发transfer方法，this.value为向父组件传递的数据
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleDownloadFile(row) {
      const filePath = row.absolutePath;
      const fileName = row.fileName;
      let url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;

      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    handleViewFile(row) {
      const url = row.serverPath;
      window.open(url);
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 55px;
}
.table {
  .table-header {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #f2f2f2;
    display: flex;
    justify-content: center;
    > div {
      width: 20%;
      display: flex;
      justify-content: center;
      > div {
        color: #036eb8;
        padding: 0 10px;
        font-size: 25px;
        cursor: pointer;
      }
    }
    > div:nth-of-type(2) {
      width: 40%;
    }
  }
  .table-none {
    text-align: center;
    color: #999;
    margin: 10px 0;
  }
  .table-body {
    .table-tr {
      display: flex;
      height: 44px;
      line-height: 44px;
      text-align: center;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #f2f2f2;
      // border-left: 1px solid #f2f2f2;
      .table-td {
        display: flex;
        justify-content: center;
        width: 20%;
        // border-right: 1px solid #f2f2f2;
      }
      .table-td:nth-of-type(2) {
        width: 40%;
      }
      .del {
        color: #ff0000;
        cursor: pointer;
      }
    }
  }
}
.scroll_row {
  max-height: 500px;
  overflow: auto;
  width: calc(100% + 30px);
  padding: 15px 30px 0 0;
  border-top: 1px solid #dcdfe6;
  .row_title {
    display: flex;
    justify-content: space-between;
    line-height: 44px;
    div:nth-of-type(1) {
      text-align: right;
    }
    div:nth-of-type(2) {
      color: #036eb8;
      cursor: pointer;
    }
    span {
      color: #f56c6c;
    }
  }
}
.history_row {
  display: flex;
  div {
    margin-right: 30px;
    line-height: 44px;
  }
}
.advice_row {
  display: flex;
  width: 100%;
  margin-top: 30px;
  > div:nth-of-type(1) {
    width: 70px;
  }
  > div:nth-of-type(2) {
    width: calc(100% - 70px);
  }
}
::v-deep.xgpg_audit_form .el-form-item {
  margin-bottom: 0;
}
</style>